module.exports = __webpack_public_path__ + "static/media/SourceSansPro-LightIt.0b6dc49a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-LightIt.eot
// module id = 86
// module chunks = 3